"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeepEqualMemo = void 0;
var useDeepEqualMemo_1 = require("./useDeepEqualMemo");
Object.defineProperty(exports, "useDeepEqualMemo", { enumerable: true, get: function () { return useDeepEqualMemo_1.useDeepEqualMemo; } });
//# sourceMappingURL=index.js.map